import React from 'react';
import { useTranslation } from 'react-i18next';
import { Payment } from '../../models';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from '../../locales/i18n';

import './PaymentTimesField.css';

const PaymentTimesField = ({ name, onChange, fixedWidth, single }) => {
    const { t } = useTranslation();

    const options = [...Array(10).keys()].map(x => ({
        key: x +1 ,
        text: t('payments.by_x_times', {x: x + 1}),
        value: x + 1
    }));

    const onFieldChange = (value) => {
        return onChange ? onChange(value) : true;
    }

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ t('payments.choose_a_time') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
            clearable
        />
    ) : (
        <MultiSelectField
            name={ name }
            options={ options }
            placeholder={ t('payments.choose_some_times') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
        />
    );
}

export default PaymentTimesField;
